module.exports = __webpack_public_path__ + "static/media/logo-unilever.ed2d16d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/logo-unilever.svg
// module id = 97
// module chunks = 0